import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN,
  LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_SUCCESS,
  LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_FAILURE,
  LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';
import initialState from './initialState';

export function listarAgendamentoRpa(filter = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN,
    filter,
  };
}

export function dismissListarAgendamentoRpaError() {
  return {
    type: LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGS_SISTEMA_LISTA_AGENDAMENTO_RPA_BEGIN actions
export function* doListarAgendamentoRpa(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const AgendamentoRPAApi = new Services['AgendamentoRPAApi']();
    res = yield AgendamentoRPAApi.find(action.filter);
  } catch (err) {
    yield put({
      type: LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListarAgendamentoRpa() {
  yield takeLatest(LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN, doListarAgendamentoRpa);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_BEGIN:
      return {
        ...state,
        listaAgendamentoRPA: initialState.listaAgendamentoRPA,
        listarAgendamentoRpaPending: true,
        listarAgendamentoRpaError: null,
      };

    case LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_SUCCESS:
      return {
        ...state,
        listaAgendamentoRPA: action.data,
        listarAgendamentoRpaPending: false,
        listarAgendamentoRpaError: null,
      };

    case LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_FAILURE:
      return {
        ...state,
        listarAgendamentoRpaPending: false,
        listarAgendamentoRpaError: action.data.error,
      };

    case LOGS_SISTEMA_LISTAR_AGENDAMENTO_RPA_DISMISS_ERROR:
      return {
        ...state,
        listarAgendamentoRpaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/logs-sistema/redux/listarAgendamentoRpa.js